import PrevadzkovaKnihaCtrl from "./PrevadzkovaKnihaCtrl";
import PrevadzkovaKnihaListCtrl from "./PrevadzkovaKnihaListCtrl";
import PrevadzkovaKnihaEditCtrl from "./PrevadzkovaKnihaEditCtrl";
import PrevadzkovaKnihaService from "./PrevadzkovaKnihaService";
import PrevadzkovaKnihaZaznamModalCtrl from "./PrevadzkovaKnihaZaznamModalCtrl";
import PrevadzkovaKnihaPrintModalCtrl from "./PrevadzkovaKnihaPrintModalCtrl";

export default angular.module("antes.prevadzkova-kniha", [])
.config(function routes($stateProvider){
  $stateProvider
  .state("prevadzkova-kniha", {
    url: "/prevadzkova-kniha/{id:int}",
    template: require("./prevadzkova-kniha.html"),
    controller: PrevadzkovaKnihaCtrl,
    controllerAs: "ctrl",
    resolve: PrevadzkovaKnihaCtrl.resolve
  })
  .state("prevadzkova-kniha-list", {
    url: "/prevadzkova-kniha?filter",
    template: require("./prevadzkova-kniha.list.html"),
    controller: PrevadzkovaKnihaListCtrl,
    controllerAs: "ctrl",
    resolve: PrevadzkovaKnihaListCtrl.resolve
  })
  .state("prevadzkova-kniha-edit", {
    url: "/prevadzkova-kniha/{id:int}/edit",
    template: require("./prevadzkova-kniha.edit.html"),
    controller: PrevadzkovaKnihaEditCtrl,
    controllerAs: "ctrl",
    resolve: PrevadzkovaKnihaEditCtrl.resolve
  })
})
.service("PrevadzkovaKnihaService", PrevadzkovaKnihaService)
.factory("PrevadzkovaKnihaZaznamModal", function($uibModal){
  return function(typOptions, data){
    return $uibModal.open({
      template: require("./prevadzkova-kniha.zaznam.modal.html"),
      controller: PrevadzkovaKnihaZaznamModalCtrl,
      controllerAs: "ctrl",
      resolve:{
        typOptions: () => typOptions,
        data: () => data
      }
    });
  };
})
.factory("PrevadzkovaKnihaPrintModal", function($uibModal){
  return function(){
    return $uibModal.open({
      template: require("./prevadzkova-kniha.print.modal.html"),
      controller: PrevadzkovaKnihaPrintModalCtrl,
      controllerAs: "ctrl"
    });
  };
})
.name;


// WEBPACK FOOTER //
// ./src/prevadzkova-kniha/index.js